import { Skeleton } from '@interco/inter-ui/components/Skeleton'

export const BannerSkeleton = () => <Skeleton width="100%" height="156px" animation="pulse" />
